export default "__VITE_ASSET__CpbpBMY$__"